module.exports = __webpack_public_path__ + "fromBrideToFather-we-y.85bf10fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-y.jpg
// module id = SWAS
// module chunks = 0